import React from 'react';
import styled from 'styled-components';

import EmbedModal, { Close, Header } from 'src/presentation/components/pages/shared/EmbedModal';

const EmbedModalWithGreenHeader = ({ content, ...otherProps }): JSX.Element => {
  const wrappedContent = <ContentContainer className={otherProps.className}>{content}</ContentContainer>;

  return <StyledEmbedModal content={wrappedContent} {...otherProps} />;
};

export const ContentContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.insetLarge} 0;
`;

const StyledEmbedModal = styled(EmbedModal)`
  ${Close} {
    background: ${({ theme }) => theme.colors.green400};
    border-radius: 8px 8px 0 0;
    height: 56px;
    margin: 0;

    svg {
      fill: ${({ theme }) => theme.colors.white};
    }
  }

  ${Header} {
    position: absolute;
    top: 18px;
    left: ${({ theme }) => theme.spacing.insetLarge};
    color: ${({ theme }) => theme.colors.white};
  }

  .modalCard-backdrop {
    z-index: 10;
    background-color: rgba(255, 255, 255, 0.8);
  }

  .modalCard-content {
    max-height: 100vh;
    padding: 0;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.04), 0px 0px 10px rgba(0, 0, 0, 0.06), 0px 0px 80px rgba(0, 0, 0, 0.06);
  }

  .Modal-backdrop {
    background-color: transparent;
  }
`;

export default EmbedModalWithGreenHeader;
